var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordResetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    style: {
      enableBackground: "new 0 0 17 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,0C6,0,3.7,1.1,2.1,2.9v-1c0-0.3-0.2-0.5-0.5-0.5S1.1,1.6,1.1,1.9v2.5c0,0.3,0.2,0.5,0.5,0.5H4 c0.3,0,0.5-0.2,0.5-0.5S4.3,3.9,4,3.9H2.7C4.1,2.1,6.2,1,8.5,1C12.6,1,16,4.4,16,8.5S12.6,16,8.5,16S1,12.6,1,8.5 c0-0.4,0-0.8,0.1-1.3C1.2,7,1,6.7,0.7,6.6C0.4,6.6,0.2,6.8,0.1,7.1C0,7.5,0,8,0,8.5C0,13.2,3.8,17,8.5,17S17,13.2,17,8.5 S13.2,0,8.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,4.1C7,4.1,5.8,5.3,5.8,6.8v0.6h0c-0.3,0-0.5,0.2-0.5,0.5v3.3c0,0.9,0.7,1.6,1.6,1.6h3.3 c0.9,0,1.6-0.7,1.6-1.6V7.9c0-0.3-0.2-0.5-0.5-0.5h0V6.8C11.2,5.3,10,4.1,8.5,4.1z M6.8,6.8c0-0.9,0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7 v0.6H6.8V6.8z M10.7,11.3c0,0.3-0.3,0.6-0.6,0.6H6.8c-0.3,0-0.6-0.3-0.6-0.6V8.5h4.5V11.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordResetIcon);
export default __webpack_public_path__ + "static/media/password-reset-icon.d380cf03fae3a74670eca99f5559c19f.svg";
export { ForwardRef as ReactComponent };